import { Box } from "@repo/components/src/ui/box";
import { DiscreteSlider } from "@repo/components/src/ui/discrete-slider";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
  FormControlLabel,
  FormControlLabelText,
} from "@repo/components/src/ui/form-control";
import { moneySchema } from "@repo/components/src/utils/yup";
import { AlertCircleIcon } from "lucide-react-native";
import { Controller, FieldValues } from "react-hook-form";
import * as yup from "yup";
import { focusScrollRef } from "../focusScrollRef";
import { FormInputProps } from "../types";

type MoneyType = yup.InferType<typeof moneySchema>;

export type FormInputTextProps<TFieldValues extends FieldValues> = Omit<
  FormInputProps<TFieldValues, MoneyType>,
  "placeholder"
> & {
  minValue: number;
  maxValue: number;
  steps: number;
};

export default function FormInputDiscreteSliderMoney<
  TFieldValues extends FieldValues,
>(props: FormInputTextProps<TFieldValues>) {
  const {
    control,
    name,
    label,
    required,
    disabled,
    className,
    size,
    minValue,
    maxValue,
    steps,
    labelSize = "md",
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <FormControl
          isInvalid={!!error}
          isRequired={required}
          isDisabled={disabled}
          className={className}
          size={size}
        >
          {!!label && (
            <FormControlLabel>
              <FormControlLabelText size={labelSize}>
                {label}
              </FormControlLabelText>
            </FormControlLabel>
          )}
          <Box className="my-2" ref={focusScrollRef(ref)}>
            <DiscreteSlider
              steps={steps}
              minValue={minValue}
              maxValue={maxValue}
              value={Number(value.amount)}
              size={size}
              onChange={(newValue) => {
                onChange({
                  ...value,
                  amount: String(newValue),
                });
              }}
            />
          </Box>
          <FormControlError>
            <FormControlErrorIcon as={AlertCircleIcon} className="mr-1" />
            <FormControlErrorText>{error?.message}</FormControlErrorText>
          </FormControlError>
        </FormControl>
      )}
    />
  );
}
